
import CarouselItem from '@/ui-kit/components/carousel-item';
import Typography from '@/ui-kit/components/typography';
import { TypographyProperty, TypographyType } from '@/ui-kit/components/typography/enums';
import Gutter from '@/ui-kit/components/gutter';
import { GutterProperty } from '@/ui-kit/components/gutter/enums';
import Button from '@/ui-kit/components/button';
import { ButtonProperty, ButtonPropsEventType } from '@/ui-kit/components/button/enums';
import {
  StylePositionType,
  StyleSizeType,
  StyleColorSchemeType,
} from '@/ui-kit/styles/enums';
import { CarouselItemActionType } from './enums';

export default {
  name: 'ContainerOverViewHeroCarouselItem',
  components: {
    CarouselItem,
    Typography,
    Gutter,
    Button,
  },
  props: {
    title: {
      default: '',
      type: String,
    },
    description: {
      default: '',
      type: String,
    },
    buttonText: {
      default: '',
      type: String,
    },
    buttonPath: {
      default: '',
      type: String,
    },
    secondButtonText: {
      default: '',
      type: String,
    },
    secondButtonPath: {
      default: '',
      type: String,
    },
  },
  data() {
    return {
      TypographyProperty,
      TypographyType,
      GutterProperty,
      ButtonProperty,
      ButtonPropsEventType,
      StylePositionType,
      StyleSizeType,
      StyleColorSchemeType,
    };
  },
  methods: {
    handlePrimaryButtonClick() {
      this.$emit(CarouselItemActionType.PrimaryButtonClick);
    },
    handleSecondaryButtonClick() {
      this.$emit(CarouselItemActionType.SecondaryButtonClick);
    },
  },
};
